import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { actions } from './Dialog';
import { InfoMessage } from './texts';
import Button from '@material-ui/core/Button';
import Dialog from '../../BuildingBlocks/Dialogs/DialogStyleTwo/Dialog';

const useStyles = makeStyles((theme: any) => ({
  continueButton: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
    minWidth: 175,
  },
}));

export default function PaymentRedirect({
  setOptionNumber,
  open,
  endRequest = null,
}) {
  const classes = useStyles();
  const header = 'Request a Change';

  const content = `This change request may result in a re-calculation.  Your active Growth Plan will remain in effect until you approve any change.`;

  const action = (
    <Button
      variant="contained"
      color="primary"
      className={classes.continueButton}
      onClick={() => setOptionNumber(actions.addMessage)}
    >
      <b>Continue</b>
    </Button>
  );

  return (
    <Dialog
      open={open}
      header={header}
      description={content}
      actions={action}
      onClose={endRequest}
      info={InfoMessage}
    />
  );
}
